import * as React from 'react'
import Card, {Props as CardProps} from 'airship/patterns/Card'
import SvgSprite from 'airship/patterns/svg-sprite'
import {RefProp, SpriteName} from '../types'

export interface Props extends CardProps {
  icon: SpriteName
  title: string
  description?: string
  badge?: React.ReactElement
}

const CardWithSvg: React.FC<RefProp<HTMLAnchorElement, Props>> = (props) => {
  const {icon, title, description, children, elementRef, badge} = props

  return (
    <Card ref={elementRef} {...props}>
      <div className="card__media">
        <SvgSprite name={icon} />
      </div>
      <div className="card__content">
        <div>
          <label>
            {title}
            {badge}
          </label>
          <p>{description}</p>
        </div>
        {children && <div>{children}</div>}
      </div>
    </Card>
  )
}

export default React.forwardRef<HTMLAnchorElement, Props>((props, ref) => (
  <CardWithSvg elementRef={ref} {...props} />
))
